export class OrganizationInviteRevokedOrInvalidError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, OrganizationInviteRevokedOrInvalidError.prototype)
  }
}
